import './error.css';
import ErrorIcon from '../../assets/error.svg';

const Error = ({
  title = 'Unable to load app',
  copy = 'Check the launcher configuration for missing parameters or errors and try again.',
}: {
  title?: string;
  copy?: string;
}) => {
  return (
    <div className="error-container">
      <img src={ErrorIcon} />

      <h1>{title}</h1>

      <h2>{copy}</h2>
    </div>
  );
};

export default Error;
